import { Card, Space } from 'antd';
import React from 'react';
import { Subscription } from '../../models/subscription-interface';

interface CompanyBillingAddressCardProps {
  subscription: Subscription | undefined;
}

export default function CompanyBillingAddressCard({
  subscription,
}: CompanyBillingAddressCardProps) {
  if (
    !subscription?.billingInfo ||
    !subscription.billingInfo.firstName?.length ||
    !subscription.billingInfo.lastName?.length ||
    !subscription.billingInfo.address1?.length ||
    !subscription.billingInfo.stateProvince?.length
  )
    return null;

  return (
    <Card>
      <Space direction='vertical'>
        <b>BILLING</b>
        <div>
          <Space direction='vertical'>
            <div>
              <b>
                {subscription.billingInfo.firstName}{' '}
                {subscription.billingInfo.lastName}
              </b>
              <br />
              {!!subscription.billingInfo.emailAddress && (
                <>
                  <a href={'mailto:' + subscription.billingInfo.emailAddress}>
                    {subscription.billingInfo.emailAddress}
                  </a>
                  <br />
                </>
              )}
            </div>
            <div>
              {subscription.billingInfo.address1}
              <br />
              {!!subscription.billingInfo.address2?.length &&
                subscription.billingInfo.address2}
              {!!subscription.billingInfo.address2?.length && <br />}
              {`${subscription.billingInfo.city}, ${subscription.billingInfo.stateProvince} ${subscription.billingInfo.postalCode}`}
              <br />
              {subscription.billingInfo.country}
            </div>
          </Space>
        </div>
      </Space>
    </Card>
  );
}
